<div>
    <div class="container-fluid fixed-top">
        <app-header></app-header>
    </div>

    <div class="container-fluid page-header py-5">
        <h1 class="text-center text-white display-6">Nosotros</h1>
        <!-- <ol class="breadcrumb justify-content-center mb-0">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Pages</a></li>
            <li class="breadcrumb-item active text-white">Contact</li>
        </ol> -->
    </div>
    <!-- Contact Start -->
    <div class="container-fluid contact py-5">
        <div class="container py-5">
            <div class="p-5 bg-light rounded">
                <div class="row g-4">
                    <div class="col-12">
                        <div class="text-center mx-auto" style="max-width: 700px;">
                            <h1 class="text-primary">Quienes Somos</h1>

                        </div>
                    </div>
                    <!-- <div class="col-lg-12">
                        <div class="h-100 rounded">
                            <iframe class="rounded w-100" style="height: 400px;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd"
                                loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div> -->
                    <div class="col-lg-6">
                        <p class="mb-4">Somos una empresa Mexicana constituida en 2004 para proveer productos ,equipos y servicios al sector salud en laboratorios clínicos.Nuestro constante crecimiento y desarrollo,hace necesario alianzas estratégicas con marcas líderes
                            nacionales y extranjeras reconocidas con estrictas normas de calidad para ofrecer productos y servicios de excelencia a nuestros clientes,socios colaboradores del sector público y privado.Nos enfocamos en las áreas de salud,farmacéutica,
                            alimenticia y educativa.la gama de productos que proveemos incluye reactivos ,instrumentos y equipos para uso de diagnóstico clínico, investigación e industrial.</p>
                    </div>
                    <div class="col-lg-6 elementor-widget-container">
                        <img fetchpriority="high" decoding="async" width="100%" height="100%" src="../../../assets/img/about-page-header.jpg" class="attachment-large size-large wp-image-4564" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->

    <div>
        <app-footer></app-footer>
    </div>
</div>